import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import member from "../../../../Assets/images/member-certificate.png";

const Member = () => {
  return (
    <div className="member_banner">
      <Container className="showcase-container">
        <Row className="justify-content-center align-items-center">
          <Col sm={12} md={6} lg={6}>
            <div className="heading-wrapper">
                <h2 className="mb-3">
                  Member of The National Association of Jewellers
                </h2>
              <p>
                We are proud to be part of The National Association of
                Jewellers, a mark of trust and excellence in the jewellery
                industry. Our membership reflects our commitment to quality,
                transparency, and the highest ethical standards in everything we
                do.
              </p>
            </div>
          </Col>
          <Col sm={12} md={6} lg={6}>
            <Image src={member} alt="member Image" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Member;
